import Sekolah from "../../../../../components/categories/siakad/lms/data_sekolah/Home";
export default function Home() {
  
  return (
    <Sekolah />
  );
}
